const WideTemplate = ({children, className, ...props}) => {
    
    
    const generateClassNames = () => {
        const classNames = [];
        classNames.push('w-[1160px] mx-auto my-8');

        if (!!className) {
            classNames.push(className);
        }
        return classNames.join(' ');
    }    

    return (
        <div className={`${generateClassNames()}`} {...props}>
            {children}
        </div>
    )
};

export default WideTemplate;